/**
 * Copyright (c) NCR Terafina
 **/
import React from 'react';
import { RedocStandalone } from 'redoc';
import { AnalyticsService } from './AnalyticsService';

/**
 * Render Redoc UI Component
 *
 */
export default function Redoc() {
  AnalyticsService.trackPageView('/', 'Redoc');
  const DEFAULT_SPEC = 'openapi.yaml';
  return (
    <RedocStandalone
      specUrl={DEFAULT_SPEC}
      options={{
        nativeScrollbars: true,
        scrollYOffset: 72,
        theme: { colors: { primary: { main: '#15697e' } } },
      }}
    />
  );
}
